var DEFAULT_CONTEXT = '';
var DEFAULT_LANGUAGE = '';
/**
 * The site context resolver - resolves the site context
 */
var SiteContextResolverService = /** @class */ (function () {
    /**
     * Setting up the siteContextMapping
     * @param {Record<string, string | null | undefined> | null | undefined} siteContextMapping
     * @memberOf SiteContextResolverService
     */
    function SiteContextResolverService(siteContextMapping) {
        this.siteContext = DEFAULT_CONTEXT;
        this.siteLanguage = DEFAULT_LANGUAGE;
        this.siteContextMapping = siteContextMapping || {};
    }
    /**
     * Setter for siteContext
     * @param {Partial<LocalConfig> | null | undefined} siteConfig
     * @memberOf SiteContextResolverService
     */
    SiteContextResolverService.prototype.setContext = function (siteConfig) {
        var _a = siteConfig || {}, siteContext = _a.siteContext, siteLanguage = _a.languageSelector;
        this.siteContext = siteContext !== null && siteContext !== void 0 ? siteContext : DEFAULT_CONTEXT;
        this.siteLanguage = siteLanguage !== null && siteLanguage !== void 0 ? siteLanguage : DEFAULT_LANGUAGE;
    };
    /**
     * Getter for mapped context
     * @return {string} siteContextMapping[siteContext] or siteContext
     * @memberOf SiteContextResolverService
     */
    SiteContextResolverService.prototype.getMappedContext = function () {
        var mappedElement = this.siteContextMapping[this.siteContext];
        return mappedElement !== null && mappedElement !== void 0 ? mappedElement : this.siteContext;
    };
    /**
     * @return {string} siteContext || DEFAULT_CONTEXT
     * @memberOf SiteContextResolverService
     */
    SiteContextResolverService.prototype.getOriginalContext = function () {
        return this.siteContext || DEFAULT_CONTEXT;
    };
    /**
     * @return {string} siteLanguage || DEFAULT_LANGUAGE
     * @memberOf SiteContextResolverService
     */
    SiteContextResolverService.prototype.getSiteLanguage = function () {
        return this.siteLanguage || DEFAULT_LANGUAGE;
    };
    return SiteContextResolverService;
}());
export { SiteContextResolverService };
//# sourceMappingURL=site-context-resolver.service.js.map